import React from "react";

const DnDContext = React.createContext({});

export default DnDContext;
